import './index.scss';

class aFile
{
    /**
     * Загрузка файла в input
     * @param input
     */
    change(input)
    {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;
        let attr = self.options.attr;

        let sizeMin = input.getAttribute(attr.size.min);
        let sizeMax = input.getAttribute(attr.size.max);
        let accept = input.getAttribute(attr.accept);
        let error = false;

        if (input.files.length)
        {
            let file = input.files[0];
            let extension = file.name.split('.')[file.name.split('.').length - 1];

            if (!self.checkAccept(accept, extension))
            {
                input.value = null;
                error = true;
                self.setInfoFiles(input, base.msg('A_FILE_ERROR_EXTENSION'), cls.fileError);
            }
            else if (sizeMin !== null && +sizeMin > file.size)
            {
                input.value = null;
                error = true;
                self.setInfoFiles(input, base.msg('A_FILE_ERROR_MIN'), cls.fileError);
            }
            else if (sizeMax !== null && +sizeMax < file.size)
            {
                input.value = null;
                error = true;
                self.setInfoFiles(input, base.msg('A_FILE_ERROR_MAX'), cls.fileError);
            }
            else
            {
                self.setInfoFiles(input, file.name + ' - ' + base.formatFileSize(file.size));
            }
        }
        else self.setInfoFiles(input, 0);

        return error;
    };

    /**
     * Проверка разрешения типа файла
     * @param accept
     * @param ext
     * @returns {boolean}
     */
    checkAccept(accept, ext)
    {
        return accept === null || accept === '' || accept.split(',').indexOf(ext.trim()) !== -1;
    };

    constructor(options)
    {
        let fCls = options && options.cls;
        let fAttr = options && options.attr;
        this.base = BX.aBase;
        this.form = BX.aForm;

        this.options = {
            attr: {
                accept: fAttr && options.attr.accept ? options.attr.accept : 'accept',
                size: {
                    min: fAttr && options.attr.accept && options.attr.accept.min ? options.attr.accept.min : 'data-size-min',
                    max: fAttr && options.attr.accept && options.attr.accept.max ? options.attr.accept.max : 'data-size-max',
                },
            },
            cls: {
                iFile: fCls && options.cls.iFile ? options.cls.iFile : 'i_file',
                questionFile: fCls && options.cls.questionFile ? options.cls.questionFile : 'form-cmp__file',
                fileInfo: fCls && options.cls.fileInfo ? options.cls.fileInfo : 'form-cmp__file-info',
                fileError: fCls && options.cls.fileError ? options.cls.fileError : '__error',
            },
            values: {},
        };
        this.options.cls = Object.assign(this.form.options.cls, this.options.cls);
    };

    /**
     * Обработка события удаления файла из input
     * @param link
     */
    deleteFile(link)
    {
        console.log('click to remove link');
        let self = this;
        let cls = self.options.cls;

        let input = link.closest('.' + cls.questionFile).querySelector('input');
        input.value = null;
        self.setInfoFiles(input, 0, '');
    }

    /**
     * Добавление информации о размере файла
     * @param input
     * @param mess
     * @param addCls
     */
    setInfoFiles(input, mess, addCls)
    {
        let self = this;
        let base = self.base;
        let cls = self.options.cls;

        let field = input.closest('.' + cls.question);
        let bInfo = field.querySelector('.' + cls.fileInfo);

        if (mess === 0 && bInfo !== null)
        {
            input.removeAttribute('title');
            base.remove(bInfo);
        }
        else
        {
            input.setAttribute('title', mess);
            if (bInfo !== null)
            {
                if (bInfo.classList.contains(cls.hidden)) bInfo.classList.remove(cls.hidden);
                bInfo.querySelector('p').innerText = mess;
                if (!bInfo.classList.contains(addCls)) bInfo.classList.add(addCls);
            }
            else
            {
                bInfo = base.create('div', [cls.fileInfo, addCls], false, '<p>' + mess + '</p>');
                let link = base.create('a', [], false, '');
                link.setAttribute('href', '#');
                bInfo.setAttribute('title', mess);
                bInfo.append(link);
                field.append(bInfo);

                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    self.deleteFile(e.target);
                });
            }
        }
    }
}

BX.aFile = new aFile();